export default "__VITE_ASSET__Bs8OLHa5__"